import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Switch_Memberships",
  "use": "icon-Switch_Memberships-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 24\" id=\"icon-Switch_Memberships\">\n  <path id=\"icon-Switch_Memberships_Switch_memebership_icon\" data-name=\"Switch memebership icon\" d=\"M12.866.352a1.286,1.286,0,0,1,1.767,0l5,4.8a1.168,1.168,0,0,1,0,1.7l-5,4.8a1.288,1.288,0,0,1-1.767,0,1.166,1.166,0,0,1,0-1.7L15.733,7.2H1.249a1.2,1.2,0,1,1,0-2.4H15.733L12.866,2.048a1.165,1.165,0,0,1,0-1.7Zm-5.733,12a1.166,1.166,0,0,1,0,1.7L4.267,16.8H18.751a1.2,1.2,0,1,1,0,2.4H4.267l2.867,2.752a1.165,1.165,0,0,1,0,1.7,1.285,1.285,0,0,1-1.767,0l-5-4.8a1.168,1.168,0,0,1,0-1.7l5-4.8a1.288,1.288,0,0,1,1.767,0Z\" transform=\"translate(0 0)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/Switch_Memberships.svg
// module id = 93
// module chunks = 0 1 2